
import isEmpty from 'lodash/isEmpty'

export const SEO_DATA_SELECTOR_COMPARISON_CUSTOM_TEXT = 'compare-text'

export default {
  props: {
    body: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isComparingModels: false,
    }
  },

  computed: {
    dataSelectorForSeo: () => SEO_DATA_SELECTOR_COMPARISON_CUSTOM_TEXT,
    shouldDisplayCustomContent() {
      return !isEmpty(this.body) && !isEmpty(this.title)
    },
  },

  watch: {
    '$route.params': {
      handler() {
        const { productA, productB } = this.$route.params
        this.isComparingModels = !isEmpty(productA) && !isEmpty(productB)
      },
      deep: true,
      immediate: true,
    },
  },
}
